import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
import { border, borderRadius, color, focusRing, typeStyle, units } from "@m/alchemy-theme";
import { useStringMap } from "../../utilities/string-map/useStringMap";
import { SearchIcon } from "../../icons/SearchIcon";
import { Field } from "../field/Field";
import { BASE_INPUT_PADDING } from "../input/Input.styled";
import { stringMapDefault } from "./SelectSearchFilter.stringMap";
export const SearchInput = styled.input `
  background-color: ${color("container")};
  border: 0;
  border-bottom: ${border()};
  ${({ isFirst }) => isFirst &&
    css `
      border-radius: ${borderRadius("extraLarge")} ${borderRadius("extraLarge")} 0 0;
    `}
  padding: ${units(1)} ${units(2)};
  margin: 0;
  width: 100%;
  color: ${(props) => color("typeBody")(props)};
  ${typeStyle("bodyS")};
  ${({ endAdornmentWidth }) => endAdornmentWidth && endAdornmentWidth > 0 ? `padding-right:${endAdornmentWidth + BASE_INPUT_PADDING + 4}px` : ""};

  &:focus {
    ${focusRing({ type: "inner" })}
  }

  [data-whatintent="touch"] &:focus,
  [data-whatintent="mouse"] &:focus {
    box-shadow: none;
  }
`;
const StyledField = styled(Field) `
  margin-bottom: 0;
`;
const componentName = "SelectSearchFilter";
export const SelectSearchFilter = forwardRef(({ inputRef, isLoading, options, onChange, stringMap: stringMapProp, ...otherProps }, ref) => {
    const stringMap = useStringMap(componentName, { stringMapDefault, stringMapProp });
    return (_jsx(StyledField, { ref: ref, "data-testid": "SelectSearchFilter", input: _jsx(SearchInput, { autoComplete: "off", onChange: onChange, onClick: (e) => e.stopPropagation(), type: "text", onFocus: (e) => e.preventDefault(), "data-select-item": true, ref: inputRef, placeholder: stringMap.placeholder, ...otherProps }), isFullWidth: true, endAdornment: _jsx(SearchIcon, { "aria-hidden": "true" }) }));
});
SelectSearchFilter.displayName = componentName;
